import React from 'react';
import { Circle } from 'rc-progress';
import { RadialProgress } from 'react-radial-progress-indicator';

import './circle-progress.style.scss';
import { isIE } from 'utils/utils';
import bizFishIcon from 'assets/svg/biz-fish.svg';

type CircleProgressBarProps = {
    value: number,
};

const CircleProgressBar: React.FC<CircleProgressBarProps> = ({ value }) => {
    const [ width, traitColor ] = [ 9, '#ebebeb' ];
    const strokeColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim() || '#fac600';

    const valueClassNames = ['value'];
    const successClassNames = ['success'];

    value < 100
        ? successClassNames.push('hide')
        : valueClassNames.push('hide');

    return (
        <div className="progress-container">
            { !isIE() && (
                <Circle
                    percent={value}
                    strokeWidth={width}
                    trailWidth={width}
                    trailColor={traitColor}
                    strokeColor={strokeColor}
                    strokeLinecap="round"
                />
            )}

            { isIE() && (
                <RadialProgress
                    width={190}
                    height={190}
                    steps={100}
                    startStep={value}
                    step={value}
                    segmented={false}
                    text={() => ('')}
                    ringThickness={0.18}
                    ringBgColour={traitColor}
                    ringFgColour={strokeColor}
                />
            )}

            <span className={valueClassNames.join(' ')}>
                { value }%
            </span>

            <span className={successClassNames.join(' ')}>
                <img src={bizFishIcon} />
            </span>
        </div>
    )
}

export default CircleProgressBar;
